"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageSchema = exports.botImageSchema = exports.userImageSchema = exports.imageBaseSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
exports.imageBaseSchema = zod_1.z.object({
    kind: zod_1.z.literal("image"),
    imageURL: zod_1.z.string(),
    alt: zod_1.z.string().optional(),
});
exports.userImageSchema = zod_1.z
    // Note: in theory there is no image from: user
    .object({ assessment: zod_1.z.null() })
    .merge(exports.imageBaseSchema)
    .merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.literal("user") }));
exports.botImageSchema = exports.imageBaseSchema.merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.enum(["bot", "system"]) }));
exports.imageSchema = zod_1.z.discriminatedUnion("from", [
    exports.userImageSchema,
    exports.botImageSchema,
]);
//# sourceMappingURL=image.js.map